
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 54.85 162.88"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"レイヤー_1","data-name":"レイヤー 1"}},[_c('circle',{staticClass:"cls-1",attrs:{"cx":"47.84","cy":"7","r":"7"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"25.29","cy":"40.24","r":"7"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"10.69","cy":"76.58","r":"7"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"7","cy":"116.92","r":"7"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"11.03","cy":"155.88","r":"7"}})])])])
          )
        }
      }
    